import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class HTTPUtils {

    private FraseService = new BehaviorSubject<string>('Carregando');
    Frase = this.FraseService.asObservable();
    
    private HideService = new BehaviorSubject<boolean>(true);
    Hide = this.HideService.asObservable();

    constructor() { }

    forceShow(frase = "Carregando"){
      this.HideService.next(true);
      this.FraseService.next(frase);
    }

    forceHide(){
      this.HideService.next(false);
      this.FraseService.next("Carregando");
    }

    forceUpdateHide(hide: boolean){
      this.HideService.next(hide);
    }

}